import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  /info/sisustusartiklid?itm=blog

  <span style="color:#85c1dc;">**FI:**</span>
  /info/vinkkejä-sisustussuunnitteluun?itm=blog

  <span style="color:#85c1dc;">**RU:**</span>
  /info/советы-по-дизайну-интерьера?itm=blog
*/
/* @__NO_SIDE_EFFECTS__ */
const m1330 = msg(
  mf`/info/sisustusartiklid?itm=blog`,
  mf`/info/vinkkejä-sisustussuunnitteluun?itm=blog`,
  mf`/info/советы-по-дизайну-интерьера?itm=blog`,
)

export { m1330 as 'w.module.blog_grid.action.url' }